import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "V",
  "description": "",
  "published": "2006-05-03T00:00:00.000Z",
  "redirect_from": ["/blog/v/swizec/422"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Remember, Remember`}<br parentName="p"></br>{`
`}{`The fifth of November,`}<br parentName="p"></br>{`
`}{`The gunpowder treason and plot.`}<br parentName="p"></br>{`
`}{`I know of no reason`}<br parentName="p"></br>{`
`}{`Why the gunpowder treason`}<br parentName="p"></br>{`
`}{`Should ever be forgot.`}</p>
    <p>{`Watched `}<a parentName="p" {...{
        "href": "http://vforvendetta.warnerbros.com/"
      }}>{`V for Vendetta`}</a>{`, made after a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/V_for_vendetta"
      }}>{`comic book of the same title`}</a>{`, today and I have to say, the movie was absolutely marvelous. The plot was great (although it kind of reminded me of `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Nineteen_Eighty-Four_(novel)"
      }}>{`Nineteen-eighty-four`}</a>{` meets `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Phantom_of_the_opera"
      }}>{`Phantom of the opera`}</a>{`). Also the acting and the directing and even the special effects were really awesomely done. The absolutely best moment was when Big Ben's clock face blew out in such a lovely fashion. It stayed completely whole whilst the whole tower just shatter and flew out towards the viewer. Awesome.`}<br parentName="p"></br>{`
`}<a parentName="p" {...{
        "href": "http://www.imdb.com/name/nm0000204/"
      }}>{`Natalie Portman`}</a>{` also did a great job as Evey Hammond, but then again she was great also in Pirates of the Caribbean. She makes a good actor really.`}</p>
    <p><img parentName="p" {...{
        "src": "/includes/editor_upload/Image/306664-200x500.jpg",
        "alt": null
      }}></img></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      